import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";

import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { connect } from "../redux/blockchain/blockchainActions";
import { fetchData } from "../redux/data/dataActions";
import { useSelector } from "react-redux";

import img1 from "../assets/asset_4.png";
import useWindowDimensions from "../hooks/useWindowDimensions";

const EcolocationRewards = () => {
  const { width } = useWindowDimensions();

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [isLoading, setLoading] = useState(false);
  const [isConnected, setConnected] = useState(false);
  const [connectBtnText, setConnectBtnText] = useState("Connect");

  const toastMessage = (message) => toast(message);

  const handleConnect = (e) => {
    e.preventDefault();
    if (blockchain.account === null) {
      setLoading(true);
      !isConnected && setConnectBtnText("Connecting...");
      dispatch(connect()).then((response) => {
        if (response !== undefined) {
          setConnected(false);
          setLoading(false);
          setConnectBtnText("Connect");
          toastMessage(response.payload);
        }
      });
      getData();
    }
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
      setConnected(true);
      setConnectBtnText("Connected");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#ecolocation-reward-h", {
        stagger: 0.1,
        opacity: 0,
        delay: 0.2,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#ecolocation-reward-img", {
        stagger: 0.1,
        opacity: 0,
        xPercent: 5,
      });

      tl.from("#ecolocation-reward-p", {
        stagger: 0.1,
        opacity: 0,
        transform: "scale(0.5) rotate(-5deg)",
      });

      tl.from("#ecolocation-reward-btn", {
        opacity: 0,
        duration: 0.1,
        y: 50,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      id="ecolocation-reward"
      style={{
        height: "100%",
        marginTop: 50,
        marginBottom: 50,
        scrollMarginTop: 150,
      }}
      className={`container ${width > 992 ? "text-left" : "text-center"}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        theme="dark"
        toastStyle={{
          top: 10,
          backgroundColor: "var(--bg)",
          border: "1px solid var(--primary)",
          marginBottom: 10,
          borderRadius: 5,
          textAlign: "center",
          fontSize: 14,
        }}
        rtl={false}
        draggable
        pauseOnHover
      />
      <div className="row justify-content-center">
        <div className={`col ${width > 992 ? "order-0" : "order-1"}`}>
          <div
            id="ecolocation-reward-h"
            style={{
              fontSize: width > 900 ? 70 : 42,
              color: "var(--primary)",
            }}
          >
            <h1 className="primary-h">
              Welcome to <br />
              Gutter Bats Planet
              <br />
              <div
                style={{
                  fontFamily: "Edo",
                  background:
                    "linear-gradient(-180deg, var(--light) 0%, var(--light) 84%)",
                  "-webkit-background-clip": "text",
                  "-webkit-text-fill-color": "transparent",
                }}
              >
                Ecolocation Reward
              </div>
            </h1>
          </div>
          <p
            id="ecolocation-reward-p"
            className="primary-p py-3"
            style={{ textAlign: width > 992 ? "left" : "center" }}
          >
            ecolocation Reward for Gutter Bat Planet Owners
            <br />
            <br />
            To get started, connect your Ethereum wallet and
            <br />
            sign in with your Twitter and Discord profiles to start
            <br />
            earning Ecolocation Reward.
            <br />
            <br />
            Plus, see all the other Gutter bats planet kings who
            <br />
            have joined the ecolocationReward.
          </p>
          <h1
            style={{
              fontFamily: "Edo",
              fontSize: width > 992 ? 48 : 32,
              color: "var(--secondary)",
            }}
          >
            Join the + Members
            <br />
            Who've signed up already
          </h1>
          <br />
        </div>
        <div
          className={`col ${width > 992 ? "order-1" : "order-0"} text-center`}
        >
          <img
            id="ecolocation-reward-img"
            className="stroked-img"
            src={img1}
            style={{ width: width > 992 ? "60%" : "75%" }}
          />
          <br />
          <br />
          <button
            id="ecolocation-reward-btn"
            className="primary-btn"
            onClick={handleConnect}
            disabled={isLoading || isConnected}
          >
            {connectBtnText}
          </button>
          <br />
          <br />
          <div>
            Connect your Ethereum Wallet now
            <br />
            to start getting ecolocation Reward!
          </div>
        </div>
      </div>
    </div>
  );
};

export default EcolocationRewards;
